import BaseAtomFamilyFactory from '../../utils/BaseAtomFamilyFactory';
import repository from '../repositories/form-submissions';

const operations = {
  __name: "form-submissions",
  read: async (action, key) => {
    return [await repository.read(key)];
  },
  create: async (action) => {
    const item = await repository.create(action.data);
    // return null not to override form data
    return [null, item];
  },
}
const formSubmissionsAtom = new BaseAtomFamilyFactory(operations, null, { rereadOnMount: false });
export default formSubmissionsAtom;
